import { readAuthQuery, stripAuthQuery } from "./authQuery";

// El token de acceso (#t= / ?t=) se captura y se saca de la URL de forma
// SÍNCRONA al arrancar (src/index.js), antes de que React renderice: así no
// llega a ningún redirect, scripts de terceros ni al historial. preloadAuth lo
// consume de acá.
let captured = null;

export const captureBootAuth = () => {
  captured = readAuthQuery(window.location.search, window.location.hash);
  stripAuthQuery();
  return captured;
};

// Una sola lectura. Si nadie capturó antes (tests), captura en el momento.
export const takeBootAuth = () => {
  const value = captured || captureBootAuth();
  captured = null;
  return value;
};
